import React, {Component} from 'react';
import {Button, Checkbox, Col, Form, Input, Modal, Row} from "antd";
import {ShowErrorNotification, ShowValidationErrorNotification} from '../../utils';
import data from "../../data";
import moment from 'moment';

class EditModal extends Component {
    state = {
        loading: false,
        visible: false,
    };

    constructor(props) {
        super(props);
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.renderForm = this.renderForm.bind(this);
    }

    showModal(record) {
        this.setState({
            record,
            loading: false,
            visible: true
        });
    };

    closeModal(record) {
        this.setState({visible: false}, () => {
            if (this.props.onClose) {
                this.props.onClose(record);
            }
        })
    };

    handleSubmit(e) {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (err) {
                return ShowValidationErrorNotification(err);
            }
            this.setState({loading: true});
            data.updateTimesheet(this.state.record.username, this.state.record.date, values)
                .then(this.closeModal)
                .catch(err => ShowErrorNotification('Error saving timesheet', err))
                .finally(() => this.setState({loading: false}));
        });
    };

    handleCancel() {
        this.closeModal();
    };

    renderForm() {
        const {getFieldDecorator} = this.props.form;
        const {record} = this.state;
        return (
            <Form onSubmit={this.handleSubmit}>
                <Row gutter={16}>
                    <Col span={8}>
                        <Form.Item label="Username">
                            <Input disabled value={record?.username} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={8}>
                        <Form.Item label="Date">
                            <Input disabled value={record?.date && moment(record.date).format('M/D/YYYY')} />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="Punch-In Time">
                            {getFieldDecorator('punch_in_time', {
                                initialValue: record?.punch_in_time
                            })(<Input autoFocus />)}
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="Punch-Out Time">
                            {getFieldDecorator('punch_out_time', {
                                initialValue: record?.punch_out_time
                            })(<Input />)}
                        </Form.Item>
                    </Col>
                </Row>
                {getFieldDecorator('enabled', {
                    initialValue: record?.enabled,
                    valuePropName: 'checked',
                })(<Checkbox>Enabled</Checkbox>)}
                <Button hidden htmlType="submit"/>
            </Form>
        );
    }

    componentDidMount() {
        if (this.props.visible) {
            this.showModal();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.visible !== this.props.visible && this.props.visible) {
            this.showModal(this.props.record);
        }
    }

    render() {
        return (
            <Modal
                visible={this.state.visible}
                title="Edit Timesheet"
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                footer={[
                    <Button
                        key="back"
                        onClick={this.handleCancel}
                    >
                        Close
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        icon={this.state.loading ? 'loading' : 'check'}
                        onClick={this.handleSubmit}
                    >
                        Save
                    </Button>
                ]}
                destroyOnClose={true}
            >
                {this.renderForm()}
            </Modal>
        );
    }
}

export default Form.create()(EditModal);
